import request from '@/utils/request'

/**
 * 获取用户列表数据
 */
export const getFormalCustomerList = data => {
  return request({
    url: '/mj/formal/list',
    params: data
  })
}

export const getFormalCustomer = data => {
  return request({
    url: '/mj/formal/getCustomerNameById',
    method: 'POST',
    params: data
  })
}

export const fixFormalCustomer = data => {
  return request({
    url: '/mj/formal/fixFormalCustomer',
    method: 'POST',
    data
  })
}

export const productBatchImport = (data) => {
  return request({
    url: '/mj/formal/productBatchImport',
    method: 'POST',
    data
  })
}

export const userBatchImport = data => {
  return request({
    url: '/mj/formal/userBatchImport',
    method: 'POST',
    data
  })
}

export const formalSearch = data => {
  return request({
    url: '/mj/formal/search',
    method: 'POST',
    data
  })
}

export const fixFlag = (data) => {
  return request({
    url: '/mj/formal/fixFlag',
    method: 'POST',
    params: data
  })
}

export const getRefundInfoByOppId = data => {
  return request({
    url: '/mj/formal/getRefundInfoByOppId',
    method: 'POST',
    params: data
  })
}

export const getInvoiceById = data => {
  return request({
    url: '/mj/formal/getInvoiceById',
    method: 'POST',
    params: data
  })
}

export const setCreditLimit = data => {
  return request({
    url: '/mj/formal/setCreditLimit',
    method: 'POST',
    params: data
  })
}

export const exportData = data => {
  return request({
    url: '/mj/formal/exportData',
    method: 'POST',
    params: data
  })
}

export const exportLaterReturnData = data => {
  return request({
    url: '/customer/product/getListAllExcelExport',
    method: 'GET',
    responseType: 'blob'
  })
}

export const addFormalCustomer = data => {
  return request({
    url: '/mj/formal/save',
    method: 'POST',
    data
  })
}

export const search = data => {
  return request({
    url: '/mj/sales/search',
    method: 'POST',
    data
  })
}

export const saveRecord = (data) => {
  return request({
    url: '/mj/sales/saveRecord',
    method: 'POST',
    data
  })
}

export const listRecord = (data) => {
  return request({
    url: '/mj/sales/listRecord',
    method: 'POST',
    data
  })
}
export const addContract = (data) => {
  return request({
    url: '/mj/formal/addContract',
    method: 'POST',
    data
  })
}

export const getContractInfoById = (data) => {
  return request({
    url: '/mj/formal/getContractInfoById',
    method: 'POST',
    params: data
  })
}

export const getContractInfoByOppId = (data) => {
  return request({
    url: '/mj/formal/getContractInfoByOppId',
    method: 'POST',
    params: data
  })
}

export const listContract = (data) => {
  return request({
    url: '/mj/formal/listContract',
    method: 'POST',
    data
  })
}

export const addInvoice = (data) => {
  return request({
    url: '/mj/formal/addInvoice',
    method: 'POST',
    data
  })
}

export const getInvoiceByContractId = (data) => {
  return request({
    url: '/mj/formal/getInvoice',
    method: 'POST',
    data
  })
}

export const customerListRes = (data) => {
  return request({
    url: '/mj/formal/customerListRes',
    params: data
  })
}

export const customerListRes1 = () => {
  return request({
    url: '/mj/formal/customerListRes1'
  })
}

export const customerListResSelect = (data) => {
  return request({
    url: '/mj/formal/customerListResSelect',
    method: 'POST',
    params: data
  })
}

export const searchCustomerList = (data) => {
  return request({
    url: '/mj/formal/searchCustomerList',
    method: 'POST',
    params: data
  })
}

export const getContractByCustomerId = (data) => {
  return request({
    url: '/mj/formal/getContractByCustomerId',
    method: 'POST',
    params: data
  })
}

export const getContracts = (data) => {
  return request({
    url: '/mj/formal/getContracts',
    method: 'POST',
    params: data
  })
}

export const getAllContracts = (data) => {
  return request({
    url: '/mj/formal/getAllContracts',
    method: 'POST',
    params: data
  })
}

export const getContractByIds = (data) => {
  return request({
    url: '/mj/formal/getContractByIds',
    method: 'POST',
    params: data
  })
}

export const updateExportOrderType = (data) => {
  return request({
    url: '/mj/formal/updateExportOrderType',
    method: 'POST',
    params: data
  })
}

export const assignSalesAssistant = (data) => {
  return request({
    url: '/mj/formal/assignSalesAssistant',
    method: 'POST',
    params: data
  })
}
